import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserProfileInterface } from './user-profile.interface';
import { ClientApiService } from '../api/api.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { Website } from '../../dashboard/websites/models/website';

@Injectable()
export class AuthService {
  /**
   * Set user profile
   * @param {UserProfileInterface} profile
   */
  set userProfile(profile: UserProfileInterface) {
    this.localStorageService.set('userProfile', profile);
  }
  /**
   * Get user profile
   * @returns {UserProfileInterface}
   */
  get userProfile(): UserProfileInterface {
    return this.localStorageService.get<UserProfileInterface>('userProfile');
  }
  get token(): string {
    if (this.userProfile) {
      return this.userProfile.token;
    } else {
      return '';
    }
  }
  set token(token: string) {
    if (this.userProfile) {
      const profile = this.userProfile;
      profile.token = token;
      this.userProfile = profile;
    }
  }
  /**
   * Get permissions logged in user
   * @returns {any}
   */
  get userPermissions() {
    return this.localStorageService.get<any>('userPermissions');
  }
  /**
   * Set permission logged in user
   * @param permissions
   */
  set userPermissions(permissions) {
    this.localStorageService.set('userPermissions', permissions);
  }
  set website(website: Website) {
    this.localStorageService.set('currentWebsite', website);
  }
  get website(): Website {
    return this.localStorageService.get<Website>('currentWebsite');
  }
  /**
   * Check if user Admin
   * @returns {boolean}
   */
  get isAdmin(): boolean {
    return this.userProfile && this.userProfile.roleId === 1;
  }

  /**
   * Check if is Enterprise User
   * @returns {boolean}
   */
  get isEnterprise(): boolean {
    return this.userProfile && this.userProfile.roleId === 2;
  }

  /**
   * Check if is User
   * @returns {boolean}
   */
  get isUser(): boolean {
    return this.userProfile && this.userProfile.roleId === 3;
  }
  loading = false;

  constructor(
    private router: Router,
    private api: ClientApiService,
    private notify: NotificationsService,
    private localStorageService: LocalStorageService
  ) {}

  login(email: string, password: string) {
    this.loading = true;
    this.api.post('tokens', {email: email, password: password})
      .subscribe(
        (data) => {
          this.userProfile = data;
          this.fetchUserPermissions().subscribe(
            res => {
              this.userPermissions = res;
              this.notify.success('Welcome', this.userProfile.username);
              this.loading = false;
              this.router.navigate(['/dashboard']);
            },
            (error: HttpErrorResponse | any) => {
              this.api.errorNotify(error);
              this.loading = false;
            }
          );
        },
      error => {
          console.log(error);
          this.loading = false;
        }
      );
  }

  resetPassoword(login): Observable<any> {
    this.loading = true;
    return this.api.post('user/forgotpassword', {login});
  }

  /**
   * Fetch user permission from API (Database)
   */
  fetchUserPermissions(): Observable<any> {
    return this.api.get('user/permissions');
  }

  /**
   * Checking if user has Permission
   *
   * @param {string} action - permission name
   * @returns {boolean}
   */
  hasPermission(action: string | boolean): boolean {
    if (typeof action === 'string') {
      try {
        return this.userPermissions.includes(action);
      } catch (e) {
        return false;
      }
    } else {
      return action;
    }
  }

  clearUserData() {
    ['userProfile', 'userPermissions', 'currentWebsite']
      .forEach(item => this.localStorageService.remove(item));
  }

  logout() {
    if (!this.userProfile) {
      return;
    }
    const userId = this.userProfile.userId;
    this.api.put(`tokens/${userId}`).subscribe(
      data => {
        console.log(data);
        this.router.navigate(['/login']);
    }, err => {
        this.router.navigate(['/login']);
      });
    this.api.eraseToken();
    this.clearUserData();
  }

  isAuthenticated() {
    return this.userProfile && this.userPermissions;
  }

  refreshToken(): Observable<any> {
    const userId = this.userProfile.userId;
    return this.api.put(`tokens/${userId}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/auth/auth.service.ts